import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { GeneralStoreService } from '../store/general.store';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private generalStoreService: GeneralStoreService,
  ) { }

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const url = state.url.split('?').shift() || '';
    const user = this.generalStoreService.getUserValue();
    const token = this.generalStoreService.getTokenValue();
    if (!user /*|| !user.userId*/ || !token) {
      this.router.navigate(['/'], { state: { url, queryParams: next.queryParams } });
      return false;
    }

    return true;
  }
}
